// extracted by mini-css-extract-plugin
export default {"headerCell":"mimic___styles_headerCell__tyzhz","text":"mimic___styles_text__ZnHLc","minimized":"mimic___styles_minimized__aK86e","tableCell":"mimic___styles_tableCell__GkJEU"};